module.exports = __webpack_public_path__ + "static/media/SPS.e08aac6c.svg";